import React, { FC, Fragment, useEffect } from 'react'
import { Box } from '@mui/material'
import { Stack } from '@mui/system'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch } from '../../store'
import reportsSelectors from '../../store/reports/reportsSelectors'
import { getReportTeam } from '../../store/reports/reportsSlice'
import usersSelectors from '../../store/users/usersSelectors'
import DividerTAG from '../DividerTAG'
import utils from './utils'

const CaseOverviewSection: FC = () => {
  const teamMembers = useSelector(usersSelectors.teamMembers)
  const selectedReport = useSelector(reportsSelectors.selectedReport)
  const dispatch = useDispatch<AppDispatch>()
  useEffect(() => {
    dispatch(getReportTeam())
  }, [])

  const renderSections = () => {
    if (selectedReport) {
      return utils.getSections(selectedReport, teamMembers).map((section, index) => {
        return (
          <Fragment key={`${section?.title}-${index}`}>
            {section.body ? (
              <>
                <Box className={'t-case-overview-section'}>
                  <span className={'t-report-question-title'}>{section.title}</span>
                  {section.body}
                </Box>
                <DividerTAG className='t-report-question-separator' />
              </>
            ) : null}
          </Fragment>
        )
      })
    }
    return <></>
  }

  return <Stack>{renderSections()}</Stack>
}

export default CaseOverviewSection
